import {apiClient} from '../foundation/apiClient';
import { MetaInfoType } from './models';

interface UpiParams {
    pa: string;
    pn?: string;
    tn?: string;
    am?: number;
    cu: string;
}

export const buildUpiURL = (vpa: string, amount: number, name: string, note: string): string => {
    const qrData: UpiParams = {
        pa: vpa,
        pn: name,
        tn: note,
        am: amount,
        cu: 'INR',
    };

    // Encode the UPI parameters into a string
    let upiString = 'upi://pay?';
    for (const key in qrData) {
        const value = qrData[key as keyof UpiParams]; // Type-safe access
        if (value !== undefined) {
            upiString += `${key}=${encodeURIComponent(value.toString())}&`; // Convert to string for encoding
        }
    }
    upiString = upiString.slice(0, -1);

    return upiString;
};

export const updatePaymentDetails = async (
    upiDetailsUpdateRequestDTO: MetaInfoType,
): Promise<void> => {
    console.log(upiDetailsUpdateRequestDTO);
    const response = await apiClient.post('user/update/upi-details', upiDetailsUpdateRequestDTO);
    return response.data;
};
